<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>For my mother and father,</span></p>
<p class="center"><span>Beth and Donen</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?5b556191